export default {"src":"https://kroemtech.ch//_next/static/media/people-chat.701091a1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};